unable to read source [project]/workspace/frontend/src/util/removeClass.ts